module.exports = __webpack_public_path__ + "img/1050400638.8c4aa7b8.jpg";